import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="w-full bg-white border-b border-gray-200" data-id="element-270">
      <div className="max-w-7xl mx-auto px-5 md:px-12 h-14 md:h-16 flex justify-between items-center" data-id="element-271">
        <div className="flex items-center" data-id="element-272">
          <Link to="/home" className="no-underline" data-id="element-273">
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo Logo" className="h-7 md:h-8" data-id="element-274" />
          </Link>
        </div>
        <nav className="hidden md:flex space-x-8" data-id="element-275">
          <Link to="/how-it-works" className="text-[#111111] no-underline hover:text-[#631bb7] transition-colors font-medium text-sm" data-id="element-276">
            How It Works
          </Link>
          <Link to="/resources" className="text-[#111111] no-underline hover:text-[#631bb7] transition-colors font-medium text-sm" data-id="element-277">
            Guides
          </Link>
          <Link to="/pricing" className="text-[#111111] no-underline hover:text-[#631bb7] transition-colors font-medium text-sm" data-id="element-278">
            Pricing
          </Link>
          <Link to="/about-us" className="text-[#111111] no-underline hover:text-[#631bb7] transition-colors font-medium text-sm" data-id="element-279">
            About Us
          </Link>
        </nav>
        <div className="hidden md:flex items-center space-x-4" data-id="element-280">
          <a href="/login" className="text-[#111111] no-underline hover:text-[#631bb7] font-medium text-sm transition-colors" data-id="element-281">
            Log in
          </a>
          <Link to="/onboarding" className="bg-[#1a0647] text-white px-5 py-2.5 rounded-md font-medium text-sm no-underline hover:bg-[#2a0a6e] transition-colors" data-id="element-282">
            Get Started
          </Link>
        </div>
        <div className="md:hidden flex items-center space-x-2" data-id="element-283">
          <a href="/login" className="text-[#111111] bg-gray-100 px-4 py-2 rounded-md font-medium text-sm no-underline hover:bg-gray-200 transition-colors" data-id="element-284">
            Log in
          </a>
          <button onClick={toggleMenu} className="text-[#111111] focus:outline-none p-2 min-h-[44px] min-w-[44px] flex items-center justify-center" aria-label="Toggle menu" data-id="element-285">
            {isMenuOpen ? <XIcon size={24} data-id="element-286" /> : <MenuIcon size={24} data-id="element-287" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden fixed inset-0 top-14 z-50 bg-white px-5 py-6 border-t border-gray-100" data-id="element-288">
          <div className="flex flex-col space-y-4" data-id="element-289">
            <Link to="/how-it-works" className="text-[#111111] text-lg py-2 no-underline hover:text-[#631bb7] font-medium" onClick={toggleMenu} data-id="element-290">
              How It Works
            </Link>
            <Link to="/resources" className="text-[#111111] text-lg py-2 no-underline hover:text-[#631bb7] font-medium" onClick={toggleMenu} data-id="element-291">
              Guides
            </Link>
            <Link to="/pricing" className="text-[#111111] text-lg py-2 no-underline hover:text-[#631bb7] font-medium" onClick={toggleMenu} data-id="element-292">
              Pricing
            </Link>
            <Link to="/about-us" className="text-[#111111] text-lg py-2 no-underline hover:text-[#631bb7] font-medium" onClick={toggleMenu} data-id="element-293">
              About Us
            </Link>
            <div className="pt-6 mt-2 border-t border-gray-100" data-id="element-294">
              <Link to="/onboarding" className="bg-[#1a0647] text-white text-center py-3.5 rounded-md font-medium no-underline hover:bg-[#2a0a6e] transition-colors block w-full" onClick={toggleMenu} data-id="element-295">
                Get Started
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}